import angular from 'angular';
import listSaveQuotesInsurance from './listSaveQuotesInsurance';

export default angular
  .module('clientInsurance.scene.saveQuotesInsurance.components', [])
  .component('listSaveQuotesInsurance', listSaveQuotesInsurance).name;
